import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchGoals = ({ offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'goals',
        params: {
            offset,
            limit
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const createGoal = ({ name, description, goal_group, access_type, end_date, members, source, track_metric, target }) => {
    return AjaxService({
        method: 'post',
        url: 'goals',
        data: {
            name,
            description,
            goal_group,
            access_type,
            end_date,
            members,
            source,
            track_metric,
            target
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchGoal = goalId => {
    return AjaxService({
        method: 'get',
        url: `goals/${goalId}`
    })
    .then(response => validateResponse(response, 'id').data)
    .catch(error => handleServerError(error, {
        silent: true
    }));
}

export const updateGoal = (goalId, { name, description, goal_group, access_type, end_date, members, source, track_metric, target }) => {
    return AjaxService({
        method: 'put',
        url: `goals/${goalId}`,
        data: {
            name,
            description,
            goal_group,
            access_type,
            end_date,
            members,
            source,
            track_metric,
            target
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const tieTasks = (goalId, task_ids) => {
    return AjaxService({
        method: 'put',
        url: `goals/${goalId}/tasks`,
        data: { task_ids }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const untieTasks = (goalId, task_ids) => {
    return AjaxService({
        method: 'delete',
        url: `goals/${goalId}/tasks`,
        data: { task_ids }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const tieMilestones = (goalId, milestone_ids) => {
    return AjaxService({
        method: 'put',
        url: `goals/${goalId}/milestones`,
        data: { milestone_ids }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const untieMilestones = (goalId, milestone_ids) => {
    return AjaxService({
        method: 'delete',
        url: `goals/${goalId}/milestones`,
        data: { milestone_ids }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const assignUsers = (goalId, members) => {
    return AjaxService({
        method: 'put',
        url: `goals/${goalId}/members`,
        data: {
            members
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const unassignUsers = (goalId, members) => {
    return AjaxService({
        method: 'delete',
        url: `goals/${goalId}/members`,
        data: {
            members
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeGoal = goalId => {
    return AjaxService({
        method: 'delete',
        url: `goals/${goalId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
